<template>
  <div>
    <v-btn
      v-if="!isEditVehicle"
      absolute
      dark
      fab
      top
      right
      color="primary"
      style="top: 10px"
      @click="toAddVehicle()"
    >
      <v-icon color="black">add</v-icon>
    </v-btn>
    <vehicleForm
      :fetching_loading="fetching_loading"
      :dialog="vehicleDialog"
      @setDialog="vehicleDialog = $event"
      :editedIndex="editedIndex"
      @setEditIndex="editedIndex = $event"
      :form="form"
    />
    <v-layout row>
      <!-- <v-flex xs4></v-flex>
      <v-flex xs4>
        <v-spacer></v-spacer>
      </v-flex>-->
      <v-flex xs12>
        <v-toolbar dense flat>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search"
            single-line
            hide-details
            style="padding: 0"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :search="search"
      :headers="headers"
      :loading="loading_message"
      :items="vehicle_list"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.vehicle_id }}</td>
        <td>
          <img
            :src="props.item.vehicle_image"
            height="40"
            width="40"
            style="padding-top: 5px"
          />
        </td>
        <td class="text-xs-center">{{ props.item.vehicle_title_th }}</td>
        <td class="text-xs-center">{{ props.item.vehicle_title_en }}</td>
        <!-- <td class="text-xs-center">{{ props.item.vehicle_title_cn }}</td> -->
        <td class="text-xs-center">{{ props.item.vehicle_price }}</td>
        <td class="text-xs-center">{{ props.item.vehicle_std_price }}</td>
        <td class="text-xs-center">{{ props.item.vehicle_price_per_point }}</td>
        <td class="justify-center layout px-0">
          <v-tooltip top>
            <v-btn
              icon
              slot="activator"
              :disabled="isEditVehicle"
              @click="editVehicle(props.item)"
            >
              <v-icon small>edit</v-icon>
            </v-btn>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              icon
              slot="activator"
              :disabled="isEditVehicle"
              @click="deleteVehicle(props.item)"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
          <v-switch
            :disabled="isEditVehicle"
            v-model="props.item.vehicle_active"
            @change="changeStatus(props.item)"
            color="primary"
            style="max-width: 50px; margin-top: 11px"
          ></v-switch>
        </td>
      </template>
      <template slot="no-data">
        <div v-if="loading_message == false">No data available</div>
        <div v-else>
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular
          >Loading data ...
        </div>
      </template>
    </v-data-table>
    <!-- <div class="text-xs-center py-2">
      <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
    </div>-->
  </div>
</template>

<script>
import vehicleForm from "./VehicleTypeDialogForm";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    vehicleForm,
  },
  data() {
    return {
      search: "",
      fetching_loading: false,
      form: {},
      loading_message: false,
      vehicleDialog: false,
      dialog: false,
      editedIndex: -1,
      switch1: true,
      pagination: {
        page: 1,
        rowsPerPage: 10,
      },
      headers: [
        { text: "No.", value: "num", align: "center", sortable: false },
        { text: "Icon", value: "icon", align: "center", sortable: false },
        {
          text: "Vehicle name TH",
          value: "vehicle_title_th",
          align: "center",
          sortable: false,
        },
        {
          text: "Vehicle name EN",
          value: "vehicle_title_en",
          align: "center",
          sortable: false,
        },
        {
          text: "Start price",
          value: "vehicle_std_price",
          align: "center",
          sortable: false,
        },
        {
          text: "Min price",
          value: "vehicle_price",
          align: "center",
          sortable: false,
        },
        {
          text: "Price per point",
          value: "vehicle_price_per_point",
          align: "center",
          sortable: false,
        },
        { text: "Action", value: "action", align: "center", sortable: false },
      ],
      addons: [
        {
          num: "1",
          name: "รถบรรทุก",
          start: 400,
          min: 500,
          perpoint: 20,
          status: "Active",
          action: "",
        },
        {
          num: "2",
          name: "รถมอเตอร์ไซค์",
          start: 40,
          min: 60,
          perpoint: 20,
          status: "Inactive",
          action: "",
        },
      ],
    };
  },
  methods: {
    async changeStatus(item) {
      let check = await this.$store.dispatch(
        "fetchMessVehicleBack/changeStatusVehicle",
        item
      );
      if (check == false) {
        item.vehicle_active = !item.vehicle_active;
      }
    },
    deleteVehicle(item) {
      confirm("Are you sure you want to delete this vehicle?") &&
        this.$store.dispatch("fetchMessVehicleBack/deleteVehicle", item);
    },
    toAddVehicle() {
      this.form = {
        vehicle_set_distance: [],
        vehicle_image: null,
      };
      this.vehicleDialog = true;
    },
    async editVehicle(item) {
      this.vehicleDialog = true;
      this.editedIndex = 1;
      this.form = {
        vehicle_set_distance: [],
        vehicle_image: null,
      };
      this.fetching_loading = true;
      this.form = await this.$store.dispatch(
        "fetchMessVehicleBack/getVehicleDetail",
        item
      );
      if (this.form.vehicle_size_carry.split(" x ")) {
        let vehicle_size_carry_list = this.form.vehicle_size_carry.split(" x ");
        if (vehicle_size_carry_list.length >= 3) {
          this.form.vehicle_size_width = vehicle_size_carry_list[0];
          this.form.vehicle_size_length = vehicle_size_carry_list[1];
          this.form.vehicle_size_height = vehicle_size_carry_list[2];
        }
      }
      this.fetching_loading = false;
    },
  },
  computed: {
    ...mapState({
      vehicle_list: (state) => state.fetchMessVehicleBack.vehicle_list,
    }),
    ...mapGetters(["isEditVehicle"]),
    pages() {
      this.pagination.totalItems = this.vehicle_list.length;
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },
  async created() {
    this.loading_message = true;
    await this.$store.dispatch("fetchMessVehicleBack/getVehicleList");
    this.loading_message = false;
  },
};
</script>